import { render, staticRenderFns } from "./TextAreaDialog.vue?vue&type=template&id=7cef573c&scoped=true"
import script from "./TextAreaDialog.vue?vue&type=script&lang=js"
export * from "./TextAreaDialog.vue?vue&type=script&lang=js"
import style0 from "./TextAreaDialog.vue?vue&type=style&index=0&id=7cef573c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cef573c",
  null
  
)

export default component.exports